<template>
  <!-- 弹出框 -->
  <a-modal
    v-model="modal.visible"
    :title="modal.title"
    @ok="handleOk"
    @cancel="cancel"
    :confirm-loading="confirmLoading"
  >
    <a-form-model
      ref="ruleForm"
      :model="formData"
      :rules="rules"
      :label-col="{ span: 4 }"
      :wrapper-col="{ span: 20 }"
    >
      <a-form-model-item label="名称" prop="descript"
        ><a-input v-model="formData.descript" :maxLength="20"
      /></a-form-model-item>
      <a-form-model-item label="代码" prop="code"
        ><a-input
          v-model="formData.code"
          :maxLength="32"
          :disabled="modal.type == 'add' ? false : true"
      /></a-form-model-item>
      <a-form-model-item label="参数值" prop="setValue"
        ><a-input v-model="formData.setValue"
      /></a-form-model-item>
      <a-form-model-item label="默认值" prop="defValue"
        ><a-input v-model="formData.defValue"
      /></a-form-model-item>
      <a-form-model-item label="备注" prop="remark"
        ><a-input v-model="formData.remark" type="textarea"
      /></a-form-model-item>
      <a-form-model-item label="排序" prop="listOrder">
        <a-input-number v-model="formData.listOrder" :min="1" :max="99999" />
      </a-form-model-item>
      <a-row>
        <a-col :span="12">
          <a-form-model-item
            label="是否停用"
            :label-col="{ span: 8 }"
            :wrapper-col="{ span: 12 }"
          >
            <a-switch
              checked-children="是"
              un-checked-children="否"
              :checked="formData.isHalt == 'T' ? true : false"
              @change="onChange('isHalt')"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </a-modal>
</template>

<script>
export default {
  name: "OptionInfo",
  data() {
    return {
      confirmLoading: false,
      //弹出框参数
      modal: {
        visible: false,
        title: "",
        type: "add"
      },
      //form
      formData: {
        catalog: "system",
        code: "",
        descript: "",
        setValue: "",
        defValue: "",
        isHalt: "F",
        listOrder: 1,
        remark: ""
      },
      //form rules
      rules: {
        code: [
          {
            required: true,
            message: "请输入代码",
            trigger: "change"
          }
        ],
        descript: [
          {
            required: true,
            message: "请输入名称",
            trigger: "change"
          }
        ]
      }
    };
  },
  created() {},
  methods: {
    showModal(type, data) {
      this.modal.visible = true;
      this.modal.title = type == "add" ? "添加参数" : "编辑参数";
      this.modal.type = type;
      if (data && type == "edit") {
        this.formData = Object.assign({}, data);
      }
    },
    onChange(column) {
      if (this.formData[column] == "T") {
        this.formData[column] = "F";
      } else {
        this.formData[column] = "T";
      }
    },
    cancel() {
      this.formData = {
        catalog: "system",
        code: "",
        descript: "",
        setValue: "",
        defValue: "",
        isHalt: "F",
        listOrder: 1,
        remark: ""
      };
      this.confirmLoading = false;
      this.$refs.ruleForm.resetFields();
      this.modal.visible = false;
    },
    /**
     * 保存
     */
    handleOk() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let param = Object.assign({}, this.formData);
          this.confirmLoading = true;
          let action = "saveSystemOption";
          if (this.modal.type == "edit") {
            action = "modifySystemOption";
          }
          this.$http.systemBksApi[action](param)
            .then(res => {
              if (res.result == 0) {
                this.cancel();
                this.$emit("success");
                this.$message.success(res.msg);
              }
            })
            .finally(() => {
              this.confirmLoading = false;
            });
        }
      });
    }
  }
};
</script>

<style></style>
